/**
 * Last-resort, self-contained screen shown when WebAssembly is unavailable and
 * Orion's E2EE crypto cannot run (issue #943).
 *
 * Intentionally has NO dependency on i18n, Zustand stores, or the crypto module:
 * - i18n loads asynchronously (http-backend) and may not be ready at boot, so the
 *   copy is hardcoded English — acceptable for this terminal error screen.
 * - It must render even when the rest of the app is non-functional.
 *
 * Tailwind classes mirror the existing ErrorFallback for visual consistency.
 */

export default function UnsupportedBrowserScreen() {
  return (
    <div
      className="flex min-h-screen w-full items-center justify-center p-6"
      role="alert"
      aria-live="assertive"
    >
      <div className="flex w-full max-w-md flex-col gap-4 rounded-lg border border-input bg-background p-6 shadow-sm">
        <h1 className="text-lg font-semibold">Orion can&rsquo;t run here</h1>
        <p className="text-sm text-muted-foreground">
          Orion needs WebAssembly to encrypt your messages. Your browser or its
          security policy &mdash; for example iOS Lockdown Mode, or a managed /
          enterprise browser &mdash; is blocking it.
        </p>
        <p className="text-sm text-muted-foreground">
          Please try a standard browser, or disable Lockdown Mode for this site.
        </p>
      </div>
    </div>
  );
}
